import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { motion } from "framer-motion"; // Importamos Framer Motion
import img from "../../assets/img/home.png";

function Header() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
  });
  const { name, email } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const submissionData = new FormData();
    submissionData.append("name", name);
    submissionData.append("email", email);

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/contacts/demo`,
        submissionData,
        config
      )
      .then(() => {
        setTimeout(() => navigate("/demo"), 1000);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Error sending message");
      });
  };

  return (
    <motion.main
      initial={{ opacity: 0, y: -20 }} // Inicio fuera de pantalla con opacidad 0
      animate={{ opacity: 1, y: 0 }} // Al cargar, aparece suavemente
      transition={{ duration: 1, ease: "easeOut" }} // Duración de la animación
      className="mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 lg:mt-16"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        {/* Lado izquierdo: Contenido de texto */}
        <motion.div
          initial={{ opacity: 0, x: -50 }} // Sale desde la izquierda
          animate={{ opacity: 1, x: 0 }} // Aparece suavemente
          transition={{ duration: 1, delay: 0.3 }} // Retardo para un mejor efecto
          className="lg:col-span-6 text-left"
        >
          <h1 className="text-3xl font-bold text-blue-800">
            Simplify Law Firm Operations with Your Virtual Office AI
          </h1>
          <p className="mt-4 text-lg text-gray-600 hidden sm:block">
            Streamline your legal practice with our comprehensive virtual office
            solution. Manage cases, schedule appointments, and collaborate
            seamlessly—all in one platform.
          </p>
          <motion.div
            // Sale desde abajo
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.6 }}
            className="mt-6"
          >
            <p className="text-lg font-medium text-gray-900 hidden sm:block">
              Experience a new era of legal efficiency. Get started today!
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }} // Efecto hover con zoom suave
              whileTap={{ scale: 0.95 }} // Efecto al hacer click
              className="mt-4 px-6 py-3 border border-transparent text-lg font-medium rounded-full text-white bg-blue-700 shadow-md hover:bg-blue-900 transition-all hidden sm:block"
              onClick={() => navigate("/services")}
            >
              Learn More
            </motion.button>
          </motion.div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="lg:col-span-6  justify-end hidden sm:block"
        >
          <img
            className="w-full h-full"
            src={img}
            alt="Virtual Office Dashboard"
          />
        </motion.div>
      </div>
    </motion.main>
  );
}

export default Header;
